export { default } from './IndicatorColor'
